import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-google-places-autocomplete';
import axios from 'axios';

import { URL_AWS } from '../../constans/servidor';

import iconcart from '../../asses/img/icon-cart.png';
import iconcart2x from '../../asses/img/icon-cart@2x.png';
import iconcart3x from '../../asses/img/icon-cart@3x.png';
import iconmoto from '../../asses/img/icon-moto.png';
import iconmoto2x from '../../asses/img/icon-moto@2x.png';
import iconmoto3x from '../../asses/img/icon-moto@3x.png';
import iconbici from '../../asses/img/icon-bici.png';
import iconbici2x from '../../asses/img/icon-bici@2x.png';
import iconbici3x from '../../asses/img/icon-bici@3x.png';
import pago_tarjeta from '../../asses/img/pago_tarjeta.png';
import pago_efectivo from '../../asses/img/Pago_efectivo.png';
import point from '../../asses/img/ponit.png';
import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const MapaComponent = (props) => {
  const [key, setKey] = useState('home');
  const [value, setValue] = useState(null);
  const [ubicacion, setUbicacion] = useState();
  const [horario, setHorario] = useState();
  const [detalleParqueadero, setDetalleParqueadero] = useState();
  const [estado, setEstado] = useState();

  const buscar = async (item) => {
    setValue(item);
    geocodeByAddress(item.label)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => setUbicacion({ lat, lng }));
  };

  const onMarkerClick = async (item) => {
    try {
      const result = await axios.get(
        `${URL_AWS}/serviciosPaginaWeb/rest/parqueadero/getDetalle/${item.codigo}`
      );
      setDetalleParqueadero(result.data.data);
      Horarios(result.data.data['horario']);
    } catch (error) {
      console.log(error);
    }
  };

  const Horarios = (horario) => {
    const regex = /([a-z]{3}-[a-z]{3}|[a-z]{3}) (\d{2}[ap]m-\d{2}:\d{2}[ap]m|\d{2}[ap]m-\d{1}[ap]m|\d{2}[ap]m-\d{2}[ap]m|\d{1}[ap]m-\d{2}:\d{2}[ap]m)/gi;
    const nombresDias = {
      'lun-lun': 'lunes',
      'mar-mar': 'martes',
      'mie-mie': 'miércoles',
      'jue-jue': 'jueves',
      'vie-vie': 'viernes',
      'sab-sab': 'sábado',
      'sab': 'sábado',
      'dom': 'domingo'
    };

    const horarios = [];
    let match;
    while ((match = regex.exec(horario)) !== null) {
      const dia = match[1];
      const horarioParts = match[2].split("-");
      const horarioInicio = formatarHora(horarioParts[0]);
      const horarioFin = formatarHora(horarioParts[1]);
      horarios.push({ dia: nombresDias[dia], hora: { inicio: horarioInicio, fin: horarioFin } });
    }

    setEstado(determinarEstado(horarios));
    setHorario(horarios);
  };

  function formatarHora(horaString) {
    const horaParts = horaString.match(/(\d+)(:\d+)?([ap]m)?/i);
    if (horaParts) {
      let horas = parseInt(horaParts[1]);
      const minutos = parseInt(horaParts[2]?.slice(1) || '00');
      const amPm = horaParts[3]?.toLowerCase();
      if (amPm === 'pm' && horas !== 12) horas += 12;
      if (horas > 12) horas -= 12;
      const minutosFormateados = minutos < 10 ? '0' + minutos : minutos;
      return (horas < 10 ? '0' : '') + horas.toString() + ':' + minutosFormateados + (amPm ? amPm.toUpperCase() : '');
    }
    return horaString;
  }

  function determinarEstado(horarios) {
    const diaActual = moment().format('dddd');
    const horaActual = moment().format('hh:mm A');
    const horarioDiaActual = horarios.find((horario) => horario.dia === diaActual);
    if (!horarioDiaActual) return 'Día no válido';

    const inicio = moment(horarioDiaActual.hora.inicio, 'hh:mm A');
    const fin = moment(horarioDiaActual.hora.fin, 'hh:mm A');
    const horaActualMoment = moment(horaActual, 'hh:mm A');

    return horaActualMoment.isBetween(inicio, fin) ? 'Abierto' : 'Cerrado';
  }

  const esParqueaderoSantafe = (detalle) => {
    return (
      detalle?.codigo === 'SANTAFE_URGENCIAS' ||
      detalle?.nombre?.toUpperCase().includes('SANTAFE URGENCIAS')
    );
  };

  const renderTarifasSantafe = () => (
    <>
      <tr className="bordeSeparador vertical-center">
        <td className="td1 text-tabla-pq">Minuto</td>
        <td className="td3 text-tabla-pq text-verde">$191</td>
        <td className="td3 text-tabla-pq text-verde">$134</td>
        <td className="td3 text-tabla-pq text-verde">$10</td>
      </tr>
      <tr className="bordeSeparador vertical-center">
        <td className="td1 text-tabla-pq">Plena (12 horas)</td>
        <td className="td3 text-tabla-pq text-azul">$36.000</td>
        <td className="td3 text-tabla-pq text-azul">$36.000</td>
        <td className="td3 text-tabla-pq text-azul">--</td>
      </tr>
      <tr className="bordeSeparador vertical-center">
        <td className="td1 text-tabla-pq">Plena (24 horas)</td>
        <td className="td3 text-tabla-pq text-azul">$72.000</td>
        <td className="td3 text-tabla-pq text-azul">--</td>
        <td className="td3 text-tabla-pq text-azul">--</td>
      </tr>
      <tr className="bordeSeparador vertical-center">
        <td className="td1 text-tabla-pq">Plena (36 horas)</td>
        <td className="td3 text-tabla-pq text-azul">$100.000</td>
        <td className="td3 text-tabla-pq text-azul">--</td>
        <td className="td3 text-tabla-pq text-azul">--</td>
      </tr>
    </>
  );

  return (
    <Row className="justify-content-center">
      <Col xs={12} sm={6} md={5} lg={3} xl={3} className="caja-filtro">
        <div className="contenerbuscador">
          <GooglePlacesAutocomplete
            selectProps={{
              value,
              placeholder: 'En donde buscas un parking',
              onChange: buscar,
            }}
            apiOptions={{ language: 'es', region: 'CO' }}
            autocompletionRequest={{ componentRestrictions: { country: ['co'] } }}
          />
        </div>

        {detalleParqueadero && (
          <div className="parqueadero-detalle">
            <div className="parqueadero-header">
              <h4>{detalleParqueadero?.nombre} <small>{detalleParqueadero?.direccion}</small></h4>
              <h4 className="verde">{estado}</h4>
            </div>

            {horario && horario.map((h, idx) => (
              <ul className="parqueadero-lista" key={idx}>
                <li><span>{h.dia}</span><span className="azul">{h.hora.inicio} - {h.hora.fin}</span></li>
              </ul>
            ))}

            <table className="cupos">
              <tr className="bordeSeparador">
                <td className="td1">Cupos</td>
                <td className="td2 text-center"><p>{detalleParqueadero?.cuposDisponiblesCarro ?? '--'}</p><img src={iconcart} className="icon-tabla" srcSet={`${iconcart2x} 2x, ${iconcart3x} 3x`} alt="cupos carros" /></td>
                <td className="td3 text-center"><p>{detalleParqueadero?.cuposDisponiblesMoto ?? '--'}</p><img src={iconmoto} className="icon-tabla" srcSet={`${iconmoto2x} 2x, ${iconmoto3x} 3x`} alt="cupos motos" /></td>
                <td className="td4 text-center"><p>{detalleParqueadero?.cuposDisponiblesBici ?? '--'}</p><img src={iconbici} className="icon-tabla" srcSet={`${iconbici2x} 2x, ${iconbici3x} 3x`} alt="cupos bici" /></td>
              </tr>
              <tr className="bordeSeparador">
                <td className="td1" colSpan="4">Tarifas</td>
              </tr>

              {esParqueaderoSantafe(detalleParqueadero)
                ? renderTarifasSantafe()
                : detalleParqueadero?.tarifasOrdenadas?.map((item, index) => (
                    <tr key={index} className={index > 0 ? 'bordeSeparador vertical-center' : 'vertical-center'}>
                      <td className="td1 text-tabla-pq">
                        {item.tipoTarifa === 'TARIFA MINUTO'
                          ? 'Minuto'
                          : item.tipoTarifa === 'TARIFA PLENA UNICA'
                          ? `Plena (${item.plena} horas)`
                          : item.tipoTarifa === 'TARIFA HORA'
                          ? 'Hora'
                          : item.tipoTarifa === 'TARIFA PLENA REPETITIVA'
                          ? 'Plena Repetitiva'
                          : '--'}
                      </td>
                      <td className={`td3 text-tabla-pq ${item.tipoTarifa === 'TARIFA MINUTO' ? 'text-verde' : 'text-azul'}`}>{item?.valorTarifaCarro ? `$${item.valorTarifaCarro}` : '--'}</td>
                      <td className={`td3 text-tabla-pq ${item.tipoTarifa === 'TARIFA MINUTO' ? 'text-verde' : 'text-azul'}`}>{item?.valorTarifaMoto ? `$${item.valorTarifaMoto}` : '--'}</td>
                      <td className={`td3 text-tabla-pq ${item.tipoTarifa === 'TARIFA MINUTO' ? 'text-verde' : 'text-azul'}`}>{item?.valorTarifaBicicleta ? `$${item.valorTarifaBicicleta}` : '--'}</td>
                    </tr>
                ))}
            </table>

            <table className="cupos">
              <tr>
                <td className="td1">Medios de pago</td>
                <td className="td2 text-center"><img src={pago_tarjeta} className="icon-tabla icon-30" alt="tarjeta" /></td>
                <td className="td3 text-center"><img src={pago_efectivo} className="icon-tabla icon-30" alt="efectivo" /></td>
              </tr>
            </table>
          </div>
        )}
      </Col>

      <Col xs={12} sm={6} md={7} lg={9} xl={9} className="pl-0 pr-0">
        <div className="mapa">
          <Map
            google={props.google}
            zoom={18}
            containerStyle={{ position: 'relative' }}
            initialCenter={{ lat: 4.6733, lng: -74.0548083 }}
            center={ubicacion}
          >
            {props.data.map((item, index) => (
              <Marker
                key={item.codigo}
                onClick={() => onMarkerClick(item)}
                name={item.nombre}
                position={{ lat: item.latitud, lng: item.longitud }}
                icon={{
                  url: point,
                  anchor: new props.google.maps.Point(32, 38),
                  scaledSize: new props.google.maps.Size(32, 38),
                }}
              />
            ))}
          </Map>
        </div>
      </Col>
    </Row>
  );
};

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAJk-OEwHaUo8VMopXL2qWTDUvK1qEZ59M',
})(MapaComponent);

